import RightSidebar from './RightSidebar.container';

export default RightSidebar;
